import { Component, inject, OnDestroy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormDropdownComponent } from '@program-suite/ui';
import { LookupViewModel, LossRunsRequestREQ, ViewSubmissionStore } from '@program-suite/data-common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormTextComponent } from '@program-suite/ui';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent, ModalLayoutComponent } from '@program-suite/ui';

export interface LossRunsModalData {
  policyGuid: string; // the policy that use is currently viewing
  businessName: string;
  policyNumber: string;
  policyTerm: string;
}

@Component({
  selector: 'lib-loss-runs-request',
  imports: [
    CommonModule,
    ModalLayoutComponent,
    ButtonComponent,
  ],
  templateUrl: './loss-runs-request.component.html',
  styleUrl: './loss-runs-request.component.scss',
})
export class LossRunsRequestComponent implements OnDestroy {
  viewSubmissionStore = inject(ViewSubmissionStore);
  data = inject(MAT_DIALOG_DATA) as LossRunsModalData;
  dialogRef = inject(MatDialogRef<LossRunsRequestComponent>);


  constructor() {
  }

  onSubmit() {
    this.viewSubmissionStore.submitLossRunRequest({ policyGuid: this.data.policyGuid }).then(() => {
      this.dialogRef.close();
    });
  }

  ngOnDestroy() {
   
  }
}
